import type { FlatAsset, FlatOrderData } from './order-box.types'

// Mapper function to transform full orderData to flat structure
export const mapOrderDataToFlat = (orderData: any): FlatOrderData => {
  if (!orderData?.data?.order) {
    return {}
  }

  const order = orderData.data.order
  const charges = order.charges || []

  const otcFeeCharge = charges.find((charge: any) => charge.key === 'OTC_FEE')
  const agentDiscountCharge = charges.find(
    (charge: any) => charge.key === 'AGENT_DISCOUNT',
  )

  return {
    orderId: order.id,
    baseAmount: order.baseAmount,
    targetAmount: order.targetAmount,
    otcFee: otcFeeCharge?.value,
    otcFeeCurrency: otcFeeCharge?.currency,
    agentDiscount: agentDiscountCharge?.value,
    agentDiscountPercentage: agentDiscountCharge?.desc?.value,
    referralName: order.referral?.name,
    referralAvatar: order.referral?.photo?.smallUrl,
  }
}

// Mapper function to transform ProjectsProject to flat asset structure
export const mapProjectToFlatAsset = (project: any): FlatAsset => {
  return {
    id: project.id || '',
    token: project.token || '',
    name: project.name || project.displayName || '',
    logoURL: project.logoURL,
    image: project.image || project.logoURL,
    province: project.province,
    district: project.district,
    state: project.state,
    tradeStatus: project.tradeStatus,
    pricePerMeter: project.pricePerMeter,
    percentChange: project.percentChange,
    type: project.type,
    availableBalance: project.availableBalance,
    balance: project.balance,
    currency: project.currency,
    accountType: project.accountType,
    minOrderSize: project.market?.minOrderSize || project?.minOrderSize || 0,
    kind: project.kind,
    scale: project.scale,
  }
}
